import React from 'react'

const TravelTypeCard = ({travelType}) => {
  return (
    <div className='travel-type-card' style={{backgroundImage:`url(${travelType.image})`}}>
        <div className='card-content'>
            <h4>{travelType.title}</h4>
            <p>{travelType.description}</p>
        </div>
    </div>
  )
}

export default TravelTypeCard